<template>
  <div>
    <section :class="`${isDark ? 'secondary white--text' : ''}  ${data.class}`">
      <v-container class="grey lighten-3">
        <v-row>
          <v-col cols="12">
            <v-switch
              label="Dark"
              dense
              @change="onChange"
              hide-details
              class="my-0 py-0"
              color="primary"
              v-model="data.dark"
            ></v-switch>
          </v-col>
          <v-col cols="12">
            <v-text-field dense label="Class" @change="onChange" v-model="data.class"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field dense label="Style" @change="onChange" v-model="data.style"></v-text-field>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "PageDivider",
  props: ["value"],
  data() {
    return {};
  },
  computed: {
    data() {
      return this.value;
    },
    isDark() {
      return this.value.dark ? true : false;
    }
  },
  methods: {
    onChange() {
      this.$emit("change");
    }
  }
};
</script>

<style>
</style>